export default "__VITE_PUBLIC_ASSET__68814f82__"